
<app-theme-switcher></app-theme-switcher>
<router-outlet></router-outlet>